import dayjs from "dayjs";
import qs from "qs";
import { ID_FILTER_REPORT_DEALERS, ID_FILTER_REPORT_LEGAL_ENTITIES, ID_FILTER_REPORT_IMPORTEDBY, ID_FILTER_REPORT_IMPORTEDDATEFROM, ID_FILTER_REPORT_IMPORTEDDATETO, ID_FILTER_REPORT_STATUSES, ID_FILTER_SEARCH } from "../../pages/enelx/constants/EnelxFilters";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useReportRepository = () => {

    const { GET, POST, DELETE } = useApi();

    const PATH = "/finance/enel-x/report"

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
       

    function getReports(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let createdBy = getFilterValue(ID_FILTER_REPORT_IMPORTEDBY, filterDefs);
        let status = getFilterValue(ID_FILTER_REPORT_STATUSES, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_REPORT_IMPORTEDDATEFROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_REPORT_IMPORTEDDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_REPORT_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_REPORT_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            createdBy: createdBy,
            status: status,
            from: dateFrom ? dayjs(dateFrom).toISOString() : null,
            to: dateTo ? dayjs(dateTo).toISOString() : null,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getReportById(id: string, config?: any): Promise<HTTPGenericResponse> {
        return GET(`${PATH}/${id}`, config);
    }

    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let createdBy = getFilterValue(ID_FILTER_REPORT_IMPORTEDBY, filterDefs);
        let status = getFilterValue(ID_FILTER_REPORT_STATUSES, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_REPORT_IMPORTEDDATEFROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_REPORT_IMPORTEDDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_REPORT_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_REPORT_DEALERS, filterDefs);
        
        let params = {
            search: search,
            createdBy: createdBy,
            status: status,
            from: dateFrom ? dayjs(dateFrom).toISOString() : null,
            to: dateTo ? dayjs(dateTo).toISOString() : null,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all-status-summary`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getCreators(search: string): Promise<HTTPGenericResponse> {
        let params = {
            search: search,
            limit: 10, legalEntities: allLegalEntities
        }
        return GET(`${PATH}/creators`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function uploadReportWithLegalEntityAndDealer(file: File, legalEntity: string, dealer: string): Promise<HTTPGenericResponse> {
        let formData = new FormData();
        formData.append("file", file); 
        formData.append("legalEntity", legalEntity);
        formData.append("dealer", dealer);

        return POST(`${PATH}/upload`, formData, { headers: { "Content-Type": "multipart/form-data" } }, true);
    }

    function deleteReport(id: string): Promise<HTTPGenericResponse> {
        return DELETE(`${PATH}/${id}`, {}, true);
    }

    return { getReports, getReportById, getSummary, getCreators, uploadReportWithLegalEntityAndDealer, deleteReport };
}